import React, { useState } from "react";

interface InvestigationsTagsProps {
  tags: string[];
  onChange: (tags: string[]) => void;
}

const InvestigationsTags: React.FC<InvestigationsTagsProps> = ({ tags, onChange }) => {
  const [inputValue, setInputValue] = useState("");

  const addTag = (val: string) => {
    const trimmed = val.trim();
    if (trimmed && !tags.includes(trimmed)) {
      onChange([...tags, trimmed]);
    }
    setInputValue("");
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addTag(inputValue);
    } else if (e.key === "Backspace" && !inputValue && tags.length > 0) {
      onChange(tags.slice(0, -1));
    }
  };

  return (
    <div className="border border-slate-200 rounded-2xl px-3 py-2.5 flex flex-wrap gap-2 min-h-[46px] focus-within:ring-2 focus-within:ring-sky-300 focus-within:border-sky-300 transition-all">
      {tags.map((tag, i) => (
        <span
          key={i}
          className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-sky-50 border border-sky-200 text-xs font-medium text-sky-700"
        >
          {tag}
          <button
            type="button"
            onClick={() => onChange(tags.filter((_, idx) => idx !== i))}
            className="text-sky-400 hover:text-sky-600 transition-colors leading-none"
          >
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </span>
      ))}
      <input
        type="text"
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => { if (inputValue.trim()) addTag(inputValue); }}
        placeholder={tags.length === 0 ? "Add investigation and press Enter…" : "Add more…"}
        className="flex-1 min-w-[160px] text-base sm:text-sm text-slate-700 placeholder-slate-400 outline-none bg-transparent py-0.5"
      />
    </div>
  );
};

export default InvestigationsTags;
